import React, { useState, useEffect } from "react";
import Input from "../../../../../../../components/Input/Input";
import Select from "../../../../../../../components/Select/Select";
import Button from "../../../../../../../components/Button/Button";
import Textarea from "../../../../../../../components/TextArea/TextArea";
import "./DetailSupport.css";
import { useLocation } from "react-router-dom";
import { usersList } from "../../../../../../../services/user";
import Modal from "../../../../../../../components/Modal/Modal";
import { useNavigate } from "react-router-dom";
//utils
import { formatDate, formatTime } from "../../../../../../../utils/utils";
//services
import { supportService } from "../../../../../../../services/Support";

const DetailSupport = () => {
  const navigate = useNavigate();
  const { support, action } = useLocation().state || {};
  const [users, setUsers] = useState([]);
  const [agent, setAgent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState({ text: "", highlight: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchUsers();
    if (support?.agent) {
      setAgent(support.agent.id);
    }
  }, [support]);

  const fetchUsers = async () => {
    try {
      const response = await usersList.getDataUser({
        page: 1,
        items_per_page: 100,
      });
      if (response.status === "success") {
        const formattedUsers = response.data.data.map((user) => ({
          value: user.id,
          label: user.name,
        }));
        setUsers(formattedUsers);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const handleAssign = async () => {
    try {
      if (!agent) {
        console.error("No agent selected");
        return;
      }

      const data = {
        status: "in_progress",
        agent_id: agent,
      };
      console.log("Assigning support:", data);
      const response = await supportService.update(support.id, data);
      if (response.status === "success") {
        console.log("Support assigned successfully:", response.data);
        setTitle({ text: "Success", highlight: "Support assigned" });
        setMessage("The support has been assigned successfully.");
        setError(false);
        setShowModal(true);
      } else {
        setTitle({ text: "Error", highlight: "Error assigning support" });
        setMessage("An error occurred while assigning the support.");
        setError(true);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error assigning support:", error);
      setTitle({ text: "Error", highlight: "Error assigning support" });
      setMessage("An error occurred while assigning the support.");
      setError(true);
      setShowModal(true);
    }
  };

  const handleConfirm = () => {
    setShowModal(false);
    navigate(-1);
  };

  return (
    <div className="detail-support-page">
      <div className="detail-support-container">
        <div className="title-container">
          <h1 className="page-title">
            <span className="highlight">
              {action === "view" ? "Consult" : "Assign"}{" "}
            </span>{" "}
            Support
          </h1>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Support folio</label>
            <Input type="text" value={support?.folio || ""} disabled={true} />
          </div>
          <div className="form-group">
            <label>Contact email</label>
            <Input type="text" value={support?.email || ""} disabled={true} />
          </div>
          <div className="form-group">
            <label>Contact number</label>
            <Input
              type="text"
              value={support?.contact_number || ""}
              disabled={true}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Reason</label>
            <Input type="text" value={support?.reason || ""} disabled={true} />
          </div>
          <div className="form-group">
            <label>Description</label>
            <Textarea value={support?.description || ""} disabled={true} />
          </div>
          <div className="form-group">
            <label>Date</label>
            <Input
              type="text"
              value={formatDate(support?.requested_at) || ""}
              disabled={true}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Time</label>
            <Input
              type="text"
              value={formatTime(support?.requested_at) || ""}
              disabled={true}
            />
          </div>
          <div className="form-group">
            <label>Status</label>
            <Input type="text" value={support?.status || ""} disabled={true} />
          </div>
          <Modal
            title={title}
            message={message}
            isOpen={showModal}
            onClose={() => setShowModal(false)}
            error={error}
            onConfirm={() => handleConfirm()}
          />
          {action === "assign" ? (
            <div className="form-group">
              <label>Supporting Agent*</label>
              <Select
                options={users}
                value={agent}
                placeholder="Select an agent"
                isClearable
                onChange={(e) =>
                  setAgent(e.target.value ? e.target.value.value : null)
                }
              />
            </div>
          ) : (
            <div className="form-group"></div>
          )}
        </div>
        {action === "assign" && (
          <div className="form-button-assign">
            <Button
              onClick={handleAssign}
              children="Assign"
              variant="warning"
              fullWidth
              borderRadius={20}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailSupport;
